import { Chip, Stack, Typography } from '@mui/material'

interface Props {
  /** Axis caption, e.g. "Driver" or "Value Type". */
  label: string
  /** The single active selection, e.g. "Media". */
  value: string
}

/** Read-only display for a cascade axis that has exactly one option: shows the active
 *  selection as context (not an interactive dropdown — there is nothing to choose). */
export function FixedAxisChip({ label, value }: Props) {
  return (
    <Stack spacing={0.5} sx={{ justifyContent: 'center', minWidth: 120 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Chip
        label={value}
        size="small"
        aria-label={`${label}: ${value}`}
        sx={{ alignSelf: 'flex-start' }}
      />
    </Stack>
  )
}
